import { registerElement, type Attrs } from "../markup/registry.js";
import { ModelStage } from "./ModelStage.js";

let registered = false;

/**
 * Teach `webwin/markup` the `<ModelStage>` element.
 *
 * Called by an application that loads scenes with a stage in them, rather than done by the markup
 * extension itself: markup is meant to cost nothing to an app with no 3D in it, and registering
 * this from there would put the whole 3D engine in every markup bundle.
 *
 * ```ts
 * import { registerStageElements } from "webwin/engine3d";
 * registerStageElements();
 * loadMarkup(`<Scene><Stage><ModelStage name="hero" src="models/ogre.glb"/></Stage>...</Scene>`, ...);
 * ```
 */
export function registerStageElements(): void {
  if (registered) return;
  registered = true;
  registerElement<ModelStage>({
    tag: "ModelStage",
    attributes: {
      src: "string",
      idle: "string",
      turnable: "boolean",
      drift: "number",
      glow: "colorRef",
      spin: "number",
      view: ["stage", "orbit"],
      parts: "list",
      highlight: "colorRef",
      outline: "colorRef",
      ghost: "number",
      reveal: "boolean",
      bloom: "number",
      sparks: "boolean",
    },
    create: (attrs: Attrs) => new ModelStage(attrs as never),
  });
}
